export default __webpack_public_path__ + "e5759740943c57bca5a07da208a6a4cb.svg";